import { DragDropModule } from '@angular/cdk/drag-drop';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import {
  FwAlertModule,
  FwAvatarModule,
  FwButtonModule,
  FwContainedInputModule,
  FwDialogsModule,
  FwIconModule,
  FwLayoutsModule,
  FwMenuModule,
  FwSelectMenuModule,
  FwTextInputModule,
  FwWrappedInputModule,
} from '@flywheel-io/vision';

import { DirectivesModule } from '../common/directives.module';
import { MaterialModule } from '../material.module';
import { FeatureIfDirective } from '../shared/directives/feature-if.directive';
import { PipesModule } from '../shared/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { DialogComponent } from './base-dialog/dialog.component';
import { BookmarkManagerDialogComponent } from './bookmark-manager-dialog/bookmark-manager-dialog.component';
import { FwLegacyChoiceDialogComponent } from './choice-dialog.component';
import { FwLegacyConfirmDialogComponent } from './confirm-dialog.component';
import { FwLegacyDialogService } from './dialog.service';
import { FwLegacyPortalDialogComponent } from './portal-dialog.component';
import { ProfileEditDialogComponent } from './profile-edit-dialog/profile-edit-dialog.component';

/**
 * @deprecated Legacy Vision: Please upgrade to the newer FwDialogsModule
 */
@NgModule({
  declarations: [
    FwLegacyChoiceDialogComponent,
    FwLegacyConfirmDialogComponent,
    FwLegacyPortalDialogComponent,
    BookmarkManagerDialogComponent,
    ProfileEditDialogComponent,
    DialogComponent,
  ],
  imports: [
    CommonModule,
    DirectivesModule,
    DragDropModule,
    FeatureIfDirective,
    FormsModule,
    FwAlertModule,
    FwAvatarModule,
    FwButtonModule,
    FwContainedInputModule,
    FwDialogsModule,
    FwLayoutsModule,
    FwIconModule,
    FwMenuModule,
    FwSelectMenuModule,
    FwTextInputModule,
    FwWrappedInputModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatTableModule,
    MaterialModule,
    SharedModule,
    PipesModule,
    PortalModule,
    ReactiveFormsModule,
  ],
  providers: [
    FwLegacyDialogService,
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        disableClose: true,
        hasBackdrop: true,
      },
    },
  ],
  exports: [FwLegacyChoiceDialogComponent, FwLegacyConfirmDialogComponent, FwLegacyPortalDialogComponent],
})
export class DialogModule {}
